import { type ReactElement, type ReactNode, } from "react";
import { SectionHeading, } from "@components";
import { Drawer, DrawerOpen } from "@bracket/react-drawers";

import "./FAQ.scss";



export const FAQ = (): ReactElement => {

	return (
		<div className="faq">
			<SectionHeading name="FAQ" blurb="We answer some frequently asked questions from the community" />
			<section className="faqs">
			<div className="drawers">
			{
				sections.map((section, idx) => {
					const [ _, title, content, ] = section as [number, string, string | ReactNode];
					const isContentString = typeof content === "string";
					return (
						<Drawer key={`faq-drawer-${idx}`}>
							<div className="left">
								<h5>{title}</h5>
							</div>
							<DrawerOpen>
								{ isContentString ? <p>{content}</p> : content }
							</DrawerOpen>
						</Drawer>
					)
				})
			}
			</div>
			</section>
		</div>
	);
};


const sections = [
	[
		1,
		"What is Bracket launching?",
		"Bracket is launching a platform for Liquid Staked DeFi, allowing users to aggregate Liquid Staked Tokens (LSTs) and Liquid Restaking Tokens (LRTs) to enhance collateral efficiency and maximize earning opportunities.",
	],
	[
		2,
		"When did Bracket begin operating?",
		"Bracket Labs started in 2021 by creating DeFi derivatives protocols. In 2023, the team was recognized by Binance and joined the Binance Labs Incubator, Season 5, where they were overall runner-up in the Build-the-Block competition.",
	],
	[
		3,
		"Why is Bracket building a platform for Liquid Staked DeFi?",
		"Bracket aims to solve the complexity and inconsistencies in DeFi utility for LST / LRT assets by creating a platform that allows the aggregation of these assets for better collateral efficiency and maximized returns.",
	],
	[
		4,
		"What is $brktETH?",
		"$brktETH is a liquid restaking token (LRT) that is comprised of a composite of liquid staking tokens (LSTs) and other LRTs. Unlike LRTs that restake LSTs to EigenLayer, $brktETH has an aggregate rate of the underlying treasury and serves as a broad-based exposure to the liquid staking and restaking markets.",
	],
	[
		5,
		"What can I do with $brktETH?",
		"$brktETH is a great way to gain broad exposure to the liquid staking market, offering a high-quality collateral-backed asset to use in DeFi. $brktETH will be most useful on the Bracket platform in Phase II of the launch when the platform is live with DeFi strategies and other opportunities.",
	],
	[
		6,
		"How will the price of $brktETH be calculated?",
		"The price of $brktETH will be calculated as the $ETH equivalent value of all its underlying collateral divided by the amount of $brktETH allocated by the smart contract. This value is dynamically calculated and transparent, with frequent updates on the Ethereum network, and recorded on-chain to the $brktETH contract on the Arbitrum network.",
	],
	[
		7,
		"What assets will be supported when staking opens?",
		<p>At first, Bracket will support a vetted shortlist of LSTs and LRTs including but not limited to stETH, rETH, eETH, rsETH, and ankrETH. Please see our documentation regarding our selection criteria <a href="https://bracket-labs.gitbook.io/bracket/bracket/usdbrkteth/managing-the-treasury/asset-selection-criteria" target="_blank">here</a></p>,
	],
	[
		8,
		"What if I only have ETH? Can I participate?",
		"Yes. Bracket requires that users convert their ETH to one of the supported LSTs or LRTs. We provide a third-party swap feature for users at the point of staking.",
	],
	[
		9,
		"For Phase I staking, will withdrawals be enabled from day 1?",
		"Yes, users can stake and withdraw at any time during Phase I.",
	],
	[
		10,
		"Will there be other LP or liquidity pools for us to participate in?",
		"Yes, in Phase II, Bracket will have LP opportunities for $brktETH that can be accessed via the platform or from third parties.",
	],
	[
		11,
		"How does the points [BARS] system work?",
		<p>Please see our documentation <a href="https://bracket-labs.gitbook.io/bracket/product/bracket-bars" target="_blank">here</a> for more on [BARS] and how to accumulate.</p>,
	],
	[
		12,
		"How do I maximize my [BARS] potential?",
		"To maximize your [BARS] accumulation, you want to stake from Day 1 to capture the TVL cap boost, use your referral link to share with your friends, and participate in community activities like quests.",
	],
	[
		13,
		"What happens during Phase II?",
		"The Phase II launch takes all staked assets and issues $brktETH, the aggregate LRT token. You can use $brktETH in our platform and in other DeFi opportunities.",
	],
	[
		14,
		"Can I withdraw my staked LST/LRTs in Phase II? What happens if I withdraw?",
		"You can withdraw at any time during Phase II and keep all the Bracket [BARS] you accrued. If you make a partial withdrawal, you will continue to accrue [BARS] on the remaining assets. Similar to LST protocols, there will be up to a 5 day delay on withdrawals in Phase II for protocol security.",
	],
	[
		15,
		"I deposited stETH but I see wstETH in my balances. Why is this?",
		<p>Bracket can only accept non-rebasing tokens, tokens that appreciate relative to ETH's value. Bracket will automatically wrap these rebasing assets for you when you deposit. For more on rebasing vs. non-rebasing, <a href="https://bracket-labs.gitbook.io/bracket/what-are-liquid-staking-tokens/liquid-staking-tokens-lsts\" target="_blank">visit our docs</a></p>
	],
	[
		16,
		"How long does it take for new [BARS] or referrals to update?",
		"[BARS] are recalculated every 24hrs, so expect your balances and referrals to update to the correct amount the next day."
	]
];
